import { Heart, Flame } from 'lucide-react'
import { ModalOverlay } from './ModalOverlay'
import { Character } from '../Character'

const F = 'Roboto, sans-serif'

interface Props {
  open: boolean
  onClose: () => void
}

export function LastChanceModal({ open, onClose }: Props) {
  return (
    <ModalOverlay open={open} onClose={onClose} borderColor="#FF3B30">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontFamily: F, gap: 12 }}>
        <Character stage={1} mood="SAD" size={100} animated={false} />
        <h2 style={{ fontSize: 20, fontWeight: 700, color: '#FF3B30', margin: 0, textAlign: 'center' }}>Последний шанс!</h2>
        <div style={{ display: 'flex', gap: 4 }}>
          <Heart size={24} color="#CBD5E0" fill="#CBD5E0" />
          <Heart size={24} color="#CBD5E0" fill="#CBD5E0" />
          <Heart size={24} color="#CBD5E0" fill="#CBD5E0" />
        </div>
        <p style={{ fontSize: 15, color: '#6B7B8D', margin: 0, textAlign: 'center', lineHeight: 1.5 }}>
          Все жизни потеряны. Выполни любое действие прямо сейчас, чтобы восстановить 1 жизнь и остаться в режиме!
        </p>
        <div style={{ display: 'flex', alignItems: 'center', gap: 4, padding: '6px 12px', borderRadius: 12, background: 'rgba(255,149,0,0.1)' }}>
          <Flame size={16} color="#F97316" />
          <span style={{ fontSize: 13, fontWeight: 600, color: '#B85C00' }}>Режим на кону!</span>
        </div>
        <button onClick={onClose} style={{ width: '100%', height: 52, borderRadius: 16, border: 'none', background: '#FF3B30', color: 'white', fontSize: 16, fontWeight: 700, cursor: 'pointer', fontFamily: F, marginTop: 4 }}>
          Выполнить действие
        </button>
      </div>
    </ModalOverlay>
  )
}
